import React from "react";
import BlockIcon from "@mui/icons-material/Block";
import "../../assets/styles/errorPages.css";

const Prohibited = ({ title, content }) => {
  return (
    <div className="error_page_container">
      <div className="error_page_content">
        {title ? (
          <h1>
            <BlockIcon /> {title}
          </h1>
        ) : (
          <></>
        )}
        {content ? <div>{content}</div> : <></>}
      </div>
    </div>
  );
};

export default Prohibited;
